export default "__VITE_ASSET__CSBBU6V2__"